import { get, patch, post, del } from "@common/services/request";
import { apiEndpoints as api } from "@common/constants/urls";
import {
  MACH_CONN_STATUS,
  MACH_STATES,
} from "@common/constants/sessionConstants";

export async function getDevices() {
  return await get(api.devices);
}

export async function getReadyToBrewDevices() {
  const response = await get(api.devices);
  return (response || []).filter((device) => {
    return (
      device.device_type === 0 &&
      device.connection_status === MACH_CONN_STATUS.MACH_CONN_STATUS_ONLINE &&
      device.process_type === MACH_STATES.MACH_STATE_IDLE
    );
  });
}

export async function getDeviceBrewReadiness(deviceUUID, recipeId) {
  const query = recipeId ? `?recipe_id=${recipeId}` : "";
  return await get(`${api.devices}${deviceUUID}/brew_readiness/${query}`);
}

export async function editDevice(serialNumber, data) {
  return await patch(`${api.devices}${serialNumber}/`, data);
}

export const addDevice = async (serialNumber) => {
  return await post(api.devices, { serial_number: serialNumber });
};

export const unregisterDevice = async (serialNumber) => {
  return await del(`${api.devices}${serialNumber}/`);
};

export async function acknowledgeTeardown(deviceUUID) {
  return await post(`${api.devices}${deviceUUID}/acknowledge_teardown/`, {});
}
